import { render, staticRenderFns } from "./ResetPasswordPhoneCodeCard.vue?vue&type=template&id=5f11a7fd&scoped=true&"
import script from "./ResetPasswordPhoneCodeCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPhoneCodeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11a7fd",
  null
  
)

export default component.exports